import React from 'react';
import { useSelector } from 'react-redux';
import { convertCoordToDMS, convertCoordsToUTM } from '../../../../../core/utils/map.utils';
import { currentCoordsState, currentCoordsToggleValueState } from '../../../../../app/redux/retrievers/retrievers';
import './styles/map.coords.display.styles.css';
import { DMSCoordinate, UTMCoordinates } from '../../../../../core/types/types';


const MapCoordinatesDisplay = () => {
    const currentCoords = useSelector(currentCoordsState);
    const currentCoordsToggleValue = useSelector(currentCoordsToggleValueState);
    const currentLatDMS: DMSCoordinate = convertCoordToDMS(currentCoords.lat);
    const currentLngDMS: DMSCoordinate = convertCoordToDMS(currentCoords.lng);
    const currentCoordsUTM: UTMCoordinates = convertCoordsToUTM(currentCoords);

    return (
        <>
            {currentCoords.lat && currentCoords.lng ? (
                <div className="map-coords-holder">
                    {currentCoordsToggleValue === 0 && (
                        <>
                            <p className="map-coords-latlng">
                                <span style={{ fontWeight: 'bold' }}>lat</span>: {currentCoords.lat}
                            </p>
                            <p className="map-coords-latlng">
                                <span style={{ fontWeight: 'bold' }}>lng</span>: {currentCoords.lng}
                            </p>
                        </>
                    )}
                    {currentCoordsToggleValue === 1 && (
                        <>
                            <p className="map-coords-latlng map-coords-dms">
                                <span style={{ fontWeight: 'bold' }}>N</span> <span> {currentLatDMS.degrees}°</span>{' '}
                                <span>{currentLatDMS.minutes}'</span> <span>{currentLatDMS.seconds}"</span>
                            </p>
                            <p className="map-coords-latlng map-coords-dms">
                                <span style={{ fontWeight: 'bold' }}>E</span> <span>{currentLngDMS.degrees}°</span>{' '}
                                <span>{currentLngDMS.minutes}'</span> <span>{currentLngDMS.seconds}"</span>
                            </p>
                        </>
                    )}
                    {currentCoordsToggleValue === 2 && (
                        <>
                            <p className="map-coords-latlng map-coords-utm">
                                <span style={{ fontWeight: 800 }}>Northing</span>: <span>{currentCoordsUTM.utmZone.northing}</span>{' '}
                                <span style={{ fontWeight: 800 }}>Easting</span>: <span>{currentCoordsUTM.utmZone.easting}</span>{' '}
                                <span style={{marginLeft: "5px", fontWeight: 800 }}> Zone</span>: {' '} <span>{currentCoordsUTM.utmZone.zoneNum}</span><span style={{ fontWeight: 'bold' }}>{currentCoordsUTM.utmZone.zoneLetter}</span>
                            </p>
                        </>
                    )}
                </div>
            ) : null}
        </>
    );
};

export default MapCoordinatesDisplay;

